import { Snackbar } from '@flatfy/supernova';
import axios from 'axios';
import { addFavorite } from '../helpers/favorites';
import { initInput } from '../UiKit/Elements/Input/Input';
import './SubscriptionBlock.scss';

class SubscribeForm {
  constructor(node) {
    if (!node) return;
    this.form = node;
    this.field = this.form.querySelector('input[type="email"]');
    this.submitButton = node.querySelector('[data-subscribe="button"]');
    this.attachListeners();
  }

  attachListeners() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(this.form);
      this.submitButton.classList.add('-loading');
      data.append('web_user_id', window.userId || '');
      axios({
        url: this.form.action,
        method: 'post',
        headers: {
          'X-CSRF-Token': window.csrf,
        },
        withCredentials: true,
        data,
      })
        .then((response) => {
          const buildingId = data.get('building_id');
          if (buildingId) addFavorite('buildings', buildingId);
          this.form.dispatchEvent(
            new CustomEvent('subscribed', { detail: { email: data.get('email') } })
          );
          return response.data.message;
        })
        .catch((error) => {
          return error.response.data.message;
        })
        .then((message) => {
          if (message) Snackbar(message);
          this.submitButton.classList.remove('-loading');
        });
    });

    initInput(this.field);
  }
}

const initSubscribeForms = () => {
  const nodes = document.querySelectorAll('[data-subscription-block]');
  Array.from(nodes).forEach(node => new SubscribeForm(node))
};

initSubscribeForms();
